"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleName;
(function (ModuleName) {
    ModuleName["App"] = "app";
    ModuleName["Auth"] = "auth";
    ModuleName["Titles"] = "titles";
    ModuleName["Home"] = "home";
    ModuleName["Spotify"] = "spotify";
    ModuleName["Playback"] = "playback";
    ModuleName["Search"] = "search";
    ModuleName["Chromecast"] = "chromecast";
    ModuleName["Channels"] = "channels";
    ModuleName["PlayerNative"] = "playerNative";
    ModuleName["Devices"] = "devices";
    ModuleName["MyStuff"] = "myStuff";
    ModuleName["RemoteRecord"] = "remoteRecord";
    ModuleName["Subscription"] = "subscription";
    ModuleName["ParentalPin"] = "parentalPin";
    ModuleName["Download2Go"] = "download2Go";
    ModuleName["UserAttributes"] = "UserAttributes";
    ModuleName["Network"] = "network";
    ModuleName["Messaging"] = "messaging";
    ModuleName["FeatureFlags"] = "featureFlags";
    ModuleName["Airplay"] = "Airplay";
    ModuleName["MyHub"] = "myHub";
    ModuleName["Recordings"] = "recordings";
    ModuleName["Decoder"] = "decoder";
    ModuleName["NotificationsTV"] = "notificationsTV";
    ModuleName["DVB"] = "dvb";
    ModuleName["ContextTV"] = "contextTV";
    ModuleName["TilesFocusTV"] = "tilesFocusTV";
    ModuleName["Purchases"] = "purchases";
    ModuleName["BackgroundImage"] = "backgroundImage";
    ModuleName["AccountPin"] = "accountPin";
    ModuleName["ProfilePreferences"] = "profilePreferences";
})(ModuleName || (ModuleName = {}));
exports.default = ModuleName;
//# sourceMappingURL=ModuleName.js.map